import React, { useState, forwardRef, useImperativeHandle, Fragment } from "react";
import AppModal from "component/Modal/AppModal";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { AccordionBody, AccordionHeader, AccordionItem, Col, Row, UncontrolledAccordion } from "reactstrap";
import FormInput from "component/FormControl/FormInput";
import { useDispatch, useSelector } from "react-redux";
import { accountsList, removeEmpSwitchAcc, switchAccount, switchAdminAcc } from "store/actions";
import AppButton from "component/Buttons/AppButton";
import Drawer from "component/Drawer/Drawer";
import StaffLoginForm from "pages/Authentication/Forms/StaffLoginForm";
import DeleteModal from "components/Common/DeleteModal";
import { me } from "constants/Client";
import MyToolTip from "component/ToolTip/ToolTip";

const SwitchAccount = ({}, ref) => {
  const apiHeader = { switch_token: me()?.switch_token };
  const dispatch = useDispatch();

  const isValid = me()?.user_token && me()?.switch_token ? false : true;

  const [isOpen, setIsOpen] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState();

  const { accounts } = useSelector(state => ({
    accounts: state.StaffView.accounts,
  }));

  const syncList = () => {
    dispatch(
      accountsList(
        {},
        () => {},
        () => {},
        apiHeader
      )
    );
  };

  const toggle = () => {
    if (!isOpen) syncList();
    setIsOpen(!isOpen);
  };

  const tLoginModal = () => {
    setLoginModal(!loginModal);
  };

  useImperativeHandle(ref, () => ({
    toggle,
  }));

  const onVerifySuccess = () => {
    syncList();
    tLoginModal();
  };

  const onDelete = agrs => {
    setRecord(agrs?.admin_switch_account_id);
    setDelModal(true);
  };

  const onDeleting = () => {
    setLoading(true);
    dispatch(
      removeEmpSwitchAcc(
        { admin_switch_account_id: record },
        () => {
          setLoading(false);
          syncList();
          setDelModal(false);
          setRecord();
        },
        () => {
          setLoading(false);
        }
      )
    );
  };

  return (
    <Fragment>
      <Drawer isOpen={isOpen} onToggle={toggle} title='Switch Account'>
        {isValid && <div className='text-center py-3 text-danger fw-bold'>Please re-login and refresh to use this feature</div>}
        <Row style={{ maxWidth: "450px" }}>
          {!localStorage.getItem("switchedATS") && (
            <Col md={12}>
              <h6 className='text-muted'>You can add more account.</h6>
              <AppButton disabled={isValid} size='sm' label='Add Account' prefixIcon={<i className='mdi mdi-account-plus-outline' />} onClick={tLoginModal} />
              <hr className='mt-4 mb-3' />
            </Col>
          )}
          <Col md={12}>
            <h6 className='text-muted'> Switch Account</h6>
            <Formik
              initialValues={{
                admin_switch_account_id: {},
              }}
              // validationSchema={Yup.object().shape({
              //   admin_switch_account_id: Yup.object().shape({
              //     value: Yup.string().required('Required'),
              //   }).nullable().required('Required'),
              // })}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(
                  switchAccount(
                    { admin_switch_account_id: values.admin_switch_account_id.value },
                    response => {
                      let user = JSON.parse(localStorage.getItem("authUser"));
                      user["user_token"] = response?.user_token;
                      localStorage.setItem("authUser", JSON.stringify(user));
                      localStorage.setItem("uid", JSON.stringify(response?.user_token));
                      if (localStorage.getItem("switchedATS")) {
                        localStorage.removeItem("switchedATS", "true");
                      } else {
                        localStorage.setItem("switchedSTA", "true");
                      }
                      setSubmitting(false);
                      window.location.href = "/";
                    },
                    () => {
                      setSubmitting(false);
                    },
                    apiHeader
                  )
                );
              }}>
              {({ setFieldValue, submitForm }) => {
                return (
                  <Form>
                    <Row>
                      <Col md={12}>
                        {accounts?.employees?.length > 0 && <h6 className='text-muted'>Employees</h6>}
                        {accounts?.employees?.map((_, key) => {
                          return (
                            <div key={key} className='border border-3 mb-2 rounded p-2 px-4 vh-center justify-content-between'>
                              <span className='text-dark ms-2'>{_?.emp_name}</span>
                              {!isValid && (
                                <MyToolTip heading='Switch'>
                                  <i
                                    role='button'
                                    className='mdi mdi-account-convert text-primary font-size-18 me-2'
                                    onClick={() => {
                                      setFieldValue("admin_switch_account_id", { label: _?.emp_name, value: _?.admin_switch_account_id });
                                      submitForm();
                                    }}
                                  />
                                </MyToolTip>
                              )}
                            </div>
                          );
                        })}
                        {accounts?.suport_worker?.length > 0 && <h6 className='text-muted mt-3'>Support Worker</h6>}
                        {accounts?.suport_worker?.map((_, key) => {
                          return (
                            <div key={key} className='border border-3 mb-2 rounded p-2 px-4 vh-center justify-content-between'>
                              <span className='text-dark ms-2'>{_?.emp_name}</span>
                              {!isValid && (
                                <MyToolTip heading='Switch'>
                                  <i
                                    role='button'
                                    className='mdi mdi-account-convert text-primary font-size-18 me-2'
                                    onClick={() => {
                                      setFieldValue("admin_switch_account_id", { label: _?.emp_name, value: _?.admin_switch_account_id });
                                      submitForm();
                                    }}
                                  />
                                </MyToolTip>
                              )}
                            </div>
                          );
                        })}
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col md={12}>
            <UncontrolledAccordion>
              <AccordionItem>
                <AccordionHeader targetId='1'>
                  <h6 className='text-danger m-0'>Remove account</h6>
                </AccordionHeader>
                <AccordionBody accordionId='1'>
                  <Formik
                    initialValues={
                      {
                        // admin_switch_account_id: {},
                      }
                    }
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      dispatch(
                        removeEmpSwitchAcc(
                          { admin_switch_account_id: values.admin_switch_account_id.value },
                          () => {
                            setSubmitting(false);
                            resetForm({ values: { admin_switch_account_id: {} } });
                            syncList();
                            setDelModal(false);
                            setRecord();
                          },
                          () => {
                            setSubmitting(false);
                          }
                        )
                      );
                    }}>
                    {({ isSubmitting, submitForm }) => {
                      return (
                        <Form>
                          <div className='d-flex gap-3 align-items-end'>
                            <div className='flex-grow-1'>
                              <FormInput
                                type='multi-select'
                                label='Account'
                                name='admin_switch_account_id'
                                inputProps={{ disabled: isValid, isMulti: false, isClearable: false, closeMenuOnSelect: true }}
                                options={[
                                  {
                                    label: "Employees",
                                    options: accounts?.employees?.map(_ => ({ label: _?.emp_name, value: _?.admin_switch_account_id })),
                                  },
                                  {
                                    label: "Support Workers",
                                    options: accounts?.suport_worker?.map(_ => ({ label: _?.emp_name, value: _?.admin_switch_account_id })),
                                  },
                                ]}
                              />
                            </div>
                            <AppButton
                              onClick={() => setDelModal(true)}
                              disabled={isValid}
                              label='Remove'
                              isSubmitting={isSubmitting}
                              outline
                              size='sm'
                              color='danger'
                              prefixIcon={<i className='mdi mdi-account-remove-outline text-danger' />}
                            />
                          </div>
                          <DeleteModal show={delModal} loading={loading} onDeleteClick={submitForm} onCloseClick={() => setDelModal(!delModal)} />
                        </Form>
                      );
                    }}
                  </Formik>
                </AccordionBody>
              </AccordionItem>
            </UncontrolledAccordion>
          </Col>
        </Row>
      </Drawer>

      <AppModal isOpen={loginModal} onToggle={tLoginModal} title='Verify Account Details'>
        <StaffLoginForm apiHeader={apiHeader} onSuccess={onVerifySuccess} />
      </AppModal>
    </Fragment>
  );
};

export default forwardRef(SwitchAccount);
